// src/pages/system/User_add.jsx
import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import SingleUserForm from "../../components/forms/SingleUserForm";
import BulkUserImport from "../../components/forms/BulkUserImport";

export default function User_add() {
  const [tab, setTab] = useState("single"); // single | bulk
  const [companies, setCompanies] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [c, d, p] = await Promise.all([
          api.get("companies/"),
          api.get("departments/"),
          api.get("positions/"),
        ]);
        setCompanies(c.data?.results ?? c.data ?? []);
        setDepartments(d.data?.results ?? d.data ?? []);
        setPositions(p.data?.results ?? p.data ?? []);
      } catch (e) {
        console.error(e);
      }
    })();
  }, []);

  return (
    <div className="p-6">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-xl font-semibold">사용자 등록</h1>
        <div className="flex rounded-lg border">
          <button
            className={`px-4 py-2 ${
              tab === "single" ? "bg-blue-600 text-white" : ""
            }`}
            onClick={() => setTab("single")}
          >
            단건 추가
          </button>
          <button
            className={`px-4 py-2 ${
              tab === "bulk" ? "bg-blue-600 text-white" : ""
            }`}
            onClick={() => setTab("bulk")}
          >
            엑셀 대량 추가
          </button>
        </div>
      </div>

      {tab === "single" ? (
        <SingleUserForm
          companies={companies}
          departments={departments}
          positions={positions}
        />
      ) : (
        <BulkUserImport
          companies={companies}
          departments={departments}
          positions={positions}
        />
      )}
    </div>
  );
}
